import DOMPurify from "dompurify";

/**
 * 공지사항 본문(HTML)을 sanitize.
 * - admin 에디터에서 작성된 HTML을 표시하기 전에 한 번 더 정화합니다.
 * - 허용 태그/속성을 화이트리스트로 제한합니다.
 */
const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "u",
  "s",
  "a",
  "ul",
  "ol",
  "li",
  "blockquote",
  "h2",
  "h3",
  "hr",
  "code",
  "span",
  "img",
];

const ALLOWED_ATTR = [
  "href",
  "rel",
  "target",
  "class",
  "src",
  "alt",
  "title",
];

/**
 * 허용 URI 스킴:
 * - https / http / mailto / tel
 * - data:image/(png|jpeg|gif|webp|svg+xml);base64,...
 */
const ALLOWED_URI_REGEXP =
  /^(?:(?:https?|mailto|tel):|data:image\/(?:png|jpe?g|gif|webp|svg\+xml);base64,|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

export function sanitizeAnnouncementHtml(html: string): string {
  if (!html) return "";
  const cleaned = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });
  if (cleaned.trim() === "<p></p>") return "";
  return cleaned;
}

/**
 * 약관 본문용 sanitize.
 * 공지사항 허용 태그 + 표(개인정보처리방침의 수집항목·보유기간 표가 본문의 핵심이라 필수).
 */
const TERMS_ALLOWED_TAGS = [
  ...ALLOWED_TAGS,
  "h4",
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "th",
  "td",
  "caption",
  "colgroup",
  "col",
];

const TERMS_ALLOWED_ATTR = [...ALLOWED_ATTR, "colspan", "rowspan", "scope"];

export function sanitizeTermsHtml(html: string): string {
  if (!html) return "";
  const cleaned = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: TERMS_ALLOWED_TAGS,
    ALLOWED_ATTR: TERMS_ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });
  if (cleaned.trim() === "<p></p>") return "";
  return cleaned;
}
